var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLock = function SvgLock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55908 5.24026C9.12538 6.01128 9 7.04912 9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 6.95088 7.12462 5.48872 7.81592 4.25974C8.17102 3.62845 8.68058 3.05012 9.39691 2.63486C10.1125 2.22005 10.979 2 12 2C13.021 2 13.8875 2.22005 14.6031 2.63486C15.3194 3.05012 15.829 3.62845 16.1841 4.25973C16.8754 5.48871 17 6.95087 17 7.99998C17.0001 8.55226 16.5524 8.99999 16.0001 9C15.4478 9.00001 15.0001 8.55231 15 8.00002C15 7.04913 14.8746 6.01129 14.4409 5.24027C14.2335 4.87155 13.9618 4.57488 13.6 4.36514C13.2375 4.15495 12.729 4 12 4C11.271 4 10.7625 4.15495 10.4 4.36514C10.0382 4.57488 9.76648 4.87155 9.55908 5.24026Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 14C14.0001 15.1046 13.1046 16 12.0001 16C10.8955 16 10.0001 15.1046 10.0001 14C10.0001 12.8954 10.8955 12 12.0001 12C13.1046 12 14.0001 12.8954 14.0001 14Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12.5523 13 13 13.4477 13 14V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14C11 13.4477 11.4477 13 12 13Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.34315 4.34315 8 6 8L18 8C19.6569 8 21 9.34315 21 11L21 19C21 20.6569 19.6569 22 18 22L6 22C4.34315 22 3 20.6569 3 19L3 11ZM6 10C5.44772 10 5 10.4477 5 11L5 19C5 19.5523 5.44772 20 6 20L18 20C18.5523 20 19 19.5523 19 19L19 11C19 10.4477 18.5523 10 18 10L6 10Z",
    fill: "black"
  })));
};
export { SvgLock as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.462a8fe3.svg";